import SquareNewWindowIcon from "../images/SquareNewWindowIcon.mjs";

/**
 * App icon for external links
 * @see {SquareNewWindowIcon}
 * @see {GlyphIcon}
 */
const AppExternalLinkIcon = class extends SquareNewWindowIcon {}

export default AppExternalLinkIcon;